// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ctm-linechart-wrap[data-v-712b28e6] {\n    height: 300px;\n    position: relative;\n}\n.ctm-linechart-empty[data-v-712b28e6] {\n    height: 300px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #9ca3af;\n    font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
